import React, { useEffect, useState, useMemo } from "react";
import he from "he";
import "./FeatureTwo.css";  
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";

const SourcingPartner = () => {
  const [sourcingContent, setSourcingContent] = useState("");
  const { page } = useSelector((state) => state.data);

  useEffect(() => {
    if (page?.statusCode === 200 && page?.data?.features) {
      setSourcingContent(he.decode(page.data.features.htmlContent));
    }
  }, [page]);

  // Memoizing the processed HTML content
  const processedContent = useMemo(() => fixImagePaths(sourcingContent), [sourcingContent]);

  return (
    <div>
      {processedContent && (
        <div className="SourcingPartner" dangerouslySetInnerHTML={{ __html: processedContent }} />
      )}
    </div>
  );
};

export default SourcingPartner;
